import { CommonRequestOptions, makeRequest } from '../makeRequest';
import { WikiPage } from './types';

type GetWikisRequestOptions = CommonRequestOptions & {
   modifiedSince?: number;
   offset?: number;
   limit?: number;
   langid?: number;
};

export async function getWikis({
   modifiedSince,
   offset,
   limit,
   langid,
   ...common
}: GetWikisRequestOptions): Promise<WikiPage[]> {
   return await makeRequest('get', 'wikis/WIKI', {
      ...common,
      query: {
         modifiedSince,
         offset,
         limit,
         langid,
      },
   });
}
